// Firma: Talep Zaman Kuralları canlı kontrolü (A: oluşturma anı, B: çalışma tarih/saati)
import { useEffect, useState } from 'react';
import axios from 'axios';
import { Clock, CalendarX, Info, Wand2 } from 'lucide-react';
import { Button } from '../../ui/button';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const KEYS = ['location_id', 'is_tipi', 'is_cesidi', 'start_date', 'end_date', 'start_time', 'end_time'];

const EMPTY = { hits: [], suggestion: null, work_rules: [] };
const post = (payload) => axios.post(`${API}/work-permits/time-rules-check`, payload).then(r => ({ ...EMPTY, ...r.data })).catch(() => EMPTY);
export const checkTimeRules = (payload) => post(payload).then(d => d.hits);

export const useTimeRuleCheck = (formData, enabled, creation) => {
  const [result, setResult] = useState(EMPTY);
  const sig = KEYS.map(k => formData[k] || '').join('|');
  useEffect(() => {
    if (!enabled) { setResult(EMPTY); return; }
    const t = setTimeout(() => {
      post({ ...Object.fromEntries(KEYS.map(k => [k, formData[k] || null])), creation, work: true }).then(setResult);
    }, 400);
    return () => clearTimeout(t);
  }, [sig, enabled, creation]);
  return result;
};

const fmt = (d) => `${d.slice(8, 10)}.${d.slice(5, 7)}.${d.slice(0, 4)}`;

export const WorkRulesInfo = ({ rules }) => (rules?.length ? (
  <div className="rounded-lg border border-sky-200 bg-sky-50/70 px-4 py-3" data-testid="work-rules-info">
    <p className="flex items-center gap-2 text-sm font-medium text-sky-900"><Info className="h-4 w-4" />Bu lokasyonda çalışma yapılamayan zamanlar</p>
    <ul className="mt-1 space-y-0.5 pl-6 text-sm text-sky-800 list-disc">
      {rules.map(r => <li key={r.id} data-testid={`work-rule-info-${r.id}`}>{r.label}{r.message && <span className="text-sky-600"> · {r.message}</span>}</li>)}
    </ul>
  </div>
) : null);

export const TimeRuleAlert = ({ hits, suggestion, onApply }) => {
  if (!hits?.length) return null;
  return (
    <div className="rounded-xl border-2 border-rose-300 bg-rose-50 p-4 space-y-2" data-testid="time-rule-alert" data-time-rule-block="true">
      {hits.map(h => (
        <p key={h.id} className="flex items-start gap-2 text-sm text-rose-800" data-testid={`time-rule-hit-${h.id}`}>
          {h.kind === 'creation' ? <Clock className="h-4 w-4 mt-0.5 shrink-0" /> : <CalendarX className="h-4 w-4 mt-0.5 shrink-0" />}
          <span><b>{h.kind === 'creation' ? 'Talep oluşturma zamanı:' : 'Çalışma zamanı:'}</b> {h.message}</span>
        </p>
      ))}
      <p className="text-xs text-rose-600">Bu kural nedeniyle talebe devam edemezsiniz. {hits.some(h => h.kind === 'work') ? 'Çalışma tarih/saatini değiştirin.' : 'Lütfen izin verilen bir zamanda tekrar deneyin.'}</p>
      {suggestion && hits.some(h => h.kind === 'work') && (
        <div className="flex flex-wrap items-center gap-3 rounded-lg border border-emerald-200 bg-white px-3 py-2" data-testid="time-rule-suggestion">
          <Wand2 className="h-4 w-4 text-emerald-600" />
          <span className="text-sm text-slate-700">En yakın uygun zaman (aynı süre): <b data-testid="time-rule-suggestion-text">{fmt(suggestion.start_date)} {suggestion.start_time} → {fmt(suggestion.end_date)} {suggestion.end_time}</b></span>
          <Button size="sm" className="ml-auto bg-emerald-600 hover:bg-emerald-700" onClick={() => onApply(suggestion)} data-testid="time-rule-apply-btn">Öneriyi Uygula</Button>
        </div>
      )}
    </div>
  );
};
